import * as fetchActions from './fetch';
import * as createActions from './create';
import * as updateActions from './update';
import * as deleteActions from './delete';

export default {
  ...createActions,
  ...fetchActions,
  ...updateActions,
  ...deleteActions,
};
